/* RESPONSIBLE TEAM: team-inbox */

import type CompanySummary from 'embercom/objects/inbox/company-summary';
import type Conversation from 'embercom/objects/inbox/conversation';

/**
 * Utility class for handling company selection logic shared between components
 */
export class CompanySelectionUtils {
  /**
   * Collects and deduplicates companies from all participants in a conversation
   */
  static getUserCompanies(conversation: Conversation): Array<CompanySummary> {
    let deduplicatedCompanies = conversation.participantSummaries
      // concatenate the lists of companies
      .reduce((list, user) => list.concat(user.companies || []), new Array<CompanySummary>())
      // deduplicate the elements in the list
      .reduce((hm, company) => (hm.set(company.id, company), hm), new Map<string, CompanySummary>())
      .values();

    return Array.from(deduplicatedCompanies);
  }

  /**
   * Determines if the company select dropdown should be shown
   */
  static shouldShowCompanySelect(
    userCompanies: Array<CompanySummary>,
    hasAssociatedCompany: boolean,
  ): boolean {
    return userCompanies.length > 0 || hasAssociatedCompany;
  }

  /**
   * Checks if a conversation has an associated company
   */
  static hasAssociatedCompany(conversation: Conversation): boolean {
    return !!conversation.companyId;
  }
}
